import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import '../jquery/jquery.min.js';
import * as $ from 'jquery';

import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import '../node_modules/file-saver/FileSaver.js';





if (environment.production) {
  enableProdMode();
}
console.log("SRM application module START");
platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts